import { remarkList } from "constants/remark";
import * as API from "../API/index";
import { authorizedUser } from "components/CommonComponent/CommonFunction";

export const addRemark = async (bodyData) => {
  try {
    const res = await API.add_remark(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const getRemarkList = async (dispatch, pageNum, filters) => {
  try {
    const res = await API.remark_list(pageNum, filters);
    dispatch({ type: remarkList, payload: res?.data });
  } catch (error) {
    authorizedUser(error.response?.data);
    dispatch({
      type: remarkList,
      payload: error?.response?.data || error,
    });
  }
};

export const getRemarkById = async (id) => {
  try {
    const res = await API.get_remark_by_ID(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const updateRemarkById = async (id, bodyData) => {
  try {
    const res = await API.edit_remark(id, bodyData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const deleteRemarkById = async (id) => {
  try {
    const res = await API.delete_remark_by_ID(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
}